module.exports = __webpack_public_path__ + "img/3.aedb41c3.png";